import gql from 'graphql-tag';

const GET_LOCATIONS = gql`
  query locations($where: LocationListWhereInput) {
    locations(where: $where) {
      id
      tag
      isEnabled
      createdAt
      updatedAt
    }
  }
`;

const GET_ENABLED_LOCATIONS = gql`
  query enabledLocations {
    enabledLocations {
      location {
        id
        tag
      }
      status
      versions
    }
  }
`;

const UPDATE_REPORT_LOCATIONS = gql`
  mutation updateReportLocations($locations: [LocationInput!]!) {
    updateReportLocations(locations: $locations) {
      id
    }
  }
`;

export { GET_LOCATIONS, GET_ENABLED_LOCATIONS, UPDATE_REPORT_LOCATIONS };
